import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/workspace/packages/shared/src/components/auth/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/shared/src/components/auth/LoginForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/shared/src/components/auth/SuperuserGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMobile"] */ "/workspace/packages/shared/src/hooks/use-mobile.ts");
;
import(/* webpackMode: "eager", webpackExports: ["AuthContext","useAuth"] */ "/workspace/packages/shared/src/lib/auth/context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useFetchCollection"] */ "/workspace/packages/shared/src/lib/hooks/useFetchCollection.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useFetchDoc"] */ "/workspace/packages/shared/src/lib/hooks/useFetchDoc.ts");
;
import(/* webpackMode: "eager", webpackExports: ["SubMenu"] */ "/workspace/packages/web/src/components/layout/SubMenu.tsx");
